import { render } from "./ProfileCopyField.vue?vue&type=template&id=3621a4f0&lang=pug"
import script from "./ProfileCopyField.vue?vue&type=script&lang=js"
export * from "./ProfileCopyField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__